export default __webpack_public_path__ + "static/media/gp_badge_hu.824eba9b.webp";